import { $Qll, $Q } from "../utils/query-selector"
import { priceVat } from "./price-vat";

const handleBadge = (value) => {
  const badge = $Q('.main-product__detail .product-disponibility .badge[data-quantity]')
  if (!badge) return

  const data = JSON.parse(badge.dataset.quantity.replaceAll("'", '"'))
  const quantity = data.quantity - Number(value)
  const badgeClass = quantity < 0 ? data.class_sale : data.class_instock
  const badgeText = quantity < 0 ? data.msg_sale : data.msg_instock
  badge.className = `badge ${badgeClass}`
  badge.textContent = badgeText;
}

export const multiplyQuantity = async (parent, value) => {
  const quantitys = $Qll(".ht", parent);
  const vatContainer = $Q(".price-product-js", parent)
  priceVat(value, vatContainer).then(() => {
    if (window.cfCurrencySwitcher) return;
    quantitys.forEach((element) => {
      const formattedPrice = parseFloat(element.dataset.price.replace(",", "."));
      const newPrice = formattedPrice * value

      // eslint-disable-next-line no-param-reassign
      element.innerText = `${newPrice.toFixed(2).replace(".", ",")}€`;
    });
  });

  handleBadge(value)
}
